import { NgModule } from '@angular/core';
import { SharedModule } from '@craftnote/shared-angular-modules';

@NgModule({
	declarations: [],
	imports: [SharedModule],
})
export class ProjectsModule {}
